import React, { useEffect } from 'react';
import { EEA4Service } from '../../../../Component/Api/Remuneration_EEA4/EEA4Serivce';
import { DataTable } from '../../../../Component/Common/Components/DataTable/DataTable';
import { ColumnSortOption } from '../../../../Component/Model/Dto/ColumnSortOption';
import { RemunerationDto } from '../../../../Component/Model/Dto/EmploymentEquity/Remuneration';
import { IndividualDrilldownSummaryDto } from '../../../../Component/Model/Dto/EmploymentEquity/WorkforceProfile_EEA2/IndividualDrilldownSummaryDto';
import { EntriesPerPage } from '../../../../Component/Model/Table/Table';
import { defaultObject } from '../../../../Helpers/typescriptHelper';
import { IndividualDrilldownMapper } from '../../../Common/EEA2/IndividualDrilldownCommon';
import { IndividualSalaryModal } from '../../../Common/Individual/IndividualSalaryModal';
import config from '../../../../config';
import { IndividualSalaryModal_Old } from '../../../Common/Individual/Old/IndividualSalaryModalOld';
import { UserActivityService } from '../../../../Component/Api/UserActivity/UserActivityService';
import { RemunerationSection } from '../../../../Component/Common/Constants/UserActivityTrackingSections';
import { UserActivityActionType } from '../../../../Component/Model/Enum/BEE123Enums';

interface IProps {
  scorecardId: string;
  occupationIds?: number[];
  raceIds?: number[];
  genderIds?: number[];
  isPermanent?: boolean | null;
  isHighestRemuneration?: boolean | null;
  isTotalDrillDown: boolean;
}

export const RemunerationDrillDown = (props: IProps) => {
  const [individualRemunerationData, setIndividualRemunerationData] =
    React.useState<IndividualDrilldownSummaryDto[]>(defaultObject);
  const [entriesPerPage, setEntriesPerPage] = React.useState<EntriesPerPage>({
    defaultValue: 10,
  });
  const [pageNumber, setPageNumber] = React.useState<number>(1);
  const [filteredItemsCount, setFilteredItemsCount] = React.useState<number>(0);
  const [totalItemsCount, setTotalItemsCount] = React.useState<number>(0);
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [searchValue, setSearchValue] = React.useState<string>('');
  const [columnSortOptions, setColumnSortOptions] = React.useState<
    ColumnSortOption[]
  >([]);

  const [selectedIndividualId, setSelectedIndividualId] =
    React.useState<number>(0);
  const [showIndividualModal, setShowIndividualModal] =
    React.useState<boolean>(false);

  const entriesPerPageChanged = (entriesPerPage: number) => {
    setEntriesPerPage({ defaultValue: entriesPerPage });
    setPageNumber(1);
  };

  const pageNumberChanged = (pageNumber: number) => {
    setPageNumber(pageNumber);
  };

  const searchValueChanged = (value: string) => {
    setSearchValue(value);
  };

  const columnSortingChanged = (sortOption: ColumnSortOption) => {
    setColumnSortOptions([sortOption]);
    setPageNumber(1);
  };

  const individualsSearchRequest: RemunerationDto.IndividualsSearchRequest = {
    occupationalLevelIds:
      props.occupationIds !== undefined ? props.occupationIds : [],
    genderIds: props.genderIds !== undefined ? props.genderIds : [],
    pageNumber: pageNumber,
    pageSize: entriesPerPage.defaultValue as number,
    raceIds: props.raceIds !== undefined ? props.raceIds : [],
    scorecardId: props.scorecardId,
    searchValue: searchValue,
    columnSortOptions: columnSortOptions,
    isPermanent: props.isPermanent,
    isHighestRemuneration: props.isHighestRemuneration,
  };

  const fetchData = async () => {
    setIsLoading(true);
    if (props.isTotalDrillDown) {
      try {
        let searchResult = await EEA4Service.SearchTotalRemunerationIndividuals(
          individualsSearchRequest
        );
        if (searchResult.data) {
          setIndividualRemunerationData(searchResult.data.results);
          setFilteredItemsCount(searchResult.data.filteredItemsCount);
          setTotalItemsCount(searchResult.data.totalItemsCount);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    } else {
      try {
        let searchResult = await EEA4Service.SearchRemunerationIndividuals(
          individualsSearchRequest
        );
        if (searchResult.data) {
          setIndividualRemunerationData(searchResult.data.results);
          setFilteredItemsCount(searchResult.data.filteredItemsCount);
          setTotalItemsCount(searchResult.data.totalItemsCount);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setIsLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchData();
  }, [entriesPerPage, pageNumber, searchValue, columnSortOptions]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    UserActivityService.createActivityLog({
      section: RemunerationSection,
      actionType: UserActivityActionType.View,
      actionDescription: "View employee remuneration",
      scorecardId: props.scorecardId,
      requestUrl: window.location.href
    });
  }, []);

  const onEdit = (id: number) => {
    setSelectedIndividualId(id);
    setShowIndividualModal(true);
  };

  const closeIndividualModal = () => {
    setShowIndividualModal(false);
    setSelectedIndividualId(0);
  };

  const remunerationDrilldownTableData = IndividualDrilldownMapper(
    individualRemunerationData,
    onEdit
  );
  return (
    <>
      <div style={{ marginTop: '-32px' }}>
        <DataTable
          table={remunerationDrilldownTableData}
          entriesPerPage={entriesPerPage}
          pageNumber={pageNumber}
          filteredItemsCount={filteredItemsCount}
          totalItemsCount={totalItemsCount}
          entriesPerPageChanged={entriesPerPageChanged}
          pageNumberChanged={pageNumberChanged}
          isLoading={isLoading}
          searchValueChanged={searchValueChanged}
          canSearch={true}
          manualSorting={true}
          columnSortingChanged={columnSortingChanged}
        ></DataTable>
      </div>

      {showIndividualModal &&
        (config.enable_employment_equity_salary === 'true' ? (
          <IndividualSalaryModal
            showIndividualModal={showIndividualModal}
            closeIndividualModal={closeIndividualModal}
            scorecardId={props.scorecardId}
            id={selectedIndividualId}
            section={RemunerationSection}
          />
        ) : (
          <IndividualSalaryModal_Old
            showIndividualModal={showIndividualModal}
            closeIndividualModal={closeIndividualModal}
            scorecardId={props.scorecardId}
            id={selectedIndividualId}
          />
        ))}
    </>
  );
};
